import React from 'react';
import {
  Box,
  Button,
  IconButton,
  IconCloseX16,
  Spinner,
  Text,
  Toast,
} from '@stitch-fix/mode-react';
import { isNonEmptyString } from '../../utils/helpers';

interface SignInFormWrapperProps {
  children: React.ReactNode;
  onSubmit: () => void;
  subheading?: React.ReactNode;
  footer?: React.ReactNode;
  ctaText?: string;
  errorMessage?: React.ReactNode;
  onErrorDismiss?: () => void;
  isLoading?: boolean;
}

export const SignInFormWrapper = ({
  children,
  onSubmit,
  subheading,
  footer,
  ctaText,
  errorMessage,
  onErrorDismiss,
  isLoading,
}: SignInFormWrapperProps) => {
  return (
    <>
      <Text setting="title-large" mb={1.5} align="center" as="h1">
        Sign in
      </Text>

      {subheading && (
        <Text setting="body-medium" align="center" mb="2rem">
          {subheading}
        </Text>
      )}

      <Box mx="auto">
        <form method="post" onSubmit={onSubmit}>
          {children}

          <Box maxWidth={21.25} mx="auto" pt={1}>
            <Button
              type="submit"
              width="fill"
              startIcon={
                isLoading ? <Spinner size="xsmall" variant="process" /> : null
              }
              disabled={isLoading}
            >
              {ctaText ?? 'Next'}
            </Button>
            {/* Display error message below CTA button if it's a react node */}
            {React.isValidElement(errorMessage) && <>{errorMessage}</>}
          </Box>
          {/* Display error message as a toast if it's a string */}
          <Toast
            isOpen={isNonEmptyString(errorMessage)}
            endContent={
              <Box my={-0.25} mx={-0.5}>
                <IconButton
                  aria-label="close"
                  onClick={onErrorDismiss}
                  variant="inherited"
                >
                  <IconCloseX16 />
                </IconButton>
              </Box>
            }
          >
            {errorMessage}
          </Toast>
        </form>

        {footer}
      </Box>
    </>
  );
};
